import gql from 'graphql-tag';

/**
 * Mutation to update the currently authenticated user's profile.
 *
 * @param input - Profile update data including displayName, avatar, banner, bio, and socialMedia (required)
 * @returns Updated profile fields including displayName, avatar with metadata, banner with metadata, bio, and socialMedia
 * @usedIn Account settings and edit profile layouts
 */
export const UPDATE_MY_PROFILE = gql`
  mutation updateMyProfile($input: UpdateMyProfileInput!) {
    updateMyProfile(input: $input) {
      displayName
      avatar {
        path
        sourceUrl
        sourceSet
        metadata {
          bucket
          mimetype
          s3Url
          filename
        }
      }
      banner {
        path
        sourceUrl
        sourceSet
        metadata {
          bucket
          mimetype
          s3Url
          filename
        }
      }
      bio
      socialMedia {
        type
        link
      }
    }
  }
`;
